import { supabase } from '@/lib/supabase'
import type { SocialProfile } from '../types'

/**
 * Fetch all social profiles
 */
export async function getProfiles(): Promise<SocialProfile[]> {
    const { data, error } = await supabase
        .from('social_profiles')
        .select('*')
        .order('name')

    if (error) throw error
    return data as SocialProfile[]
}

/**
 * Create a new social profile
 */
export async function createProfile(profile: Partial<SocialProfile>): Promise<SocialProfile> {
    const { data, error } = await supabase
        .from('social_profiles')
        .insert({
            ...profile,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
        })
        .select()
        .single()

    if (error) throw error
    return data as SocialProfile
}

/**
 * Update an existing social profile
 */
export async function updateProfile(id: string, updates: Partial<SocialProfile>): Promise<SocialProfile> {
    const { data, error } = await supabase
        .from('social_profiles')
        .update({
            ...updates,
            updated_at: new Date().toISOString()
        })
        .eq('id', id)
        .select()
        .single()

    if (error) throw error
    return data as SocialProfile
}

/**
 * Delete a social profile
 */
export async function deleteProfile(id: string): Promise<void> {
    const { error } = await supabase
        .from('social_profiles')
        .delete()
        .eq('id', id)

    if (error) throw error
}
